jQuery(document).ready(function ($) {
    "use strict";

    const ContactModal = {
        init: function () {
            var backdrop = $('#contact-modal-backdrop');

            $('.js-contact-link').on('click', function (ev) {
                ev.preventDefault();
                backdrop.removeClass('hidden');
            });
            $('.js-link-close').on('click', function (ev) {
                ev.preventDefault();
                backdrop.addClass('hidden');
            });
        }
    };

    ContactModal.init();
});
